export const BASE_PRODUCT_KEYS = {
  K1A: 'k1a',
  S3B_KIOSK: 's3b-kiosk',
  STAND_FLOOR_MOUNT: 'bundle-square-stand-with-floor-mount',
};

export const PRODUCT_ALTERNATIVE_CATEGORIES = Object.freeze({
  KIOSK_MOUNT: 'kiosk_mount',
});
